import { RecommendationsList } from '@/components/recommendations/RecommendationsList';

export default function RecommendationsPage() {
  return <RecommendationsList />;
}